import { ReportTypeAPI } from 'App';
import { prop, uniqBy } from 'ramda';

export const getChartData = (regions: ReportTypeAPI['regions']) => {
  const columns = [
    { type: 'string', id: 'Type' },
    { type: 'date', id: 'Start' },
    { type: 'date', id: 'End' },
  ];
  const rows = regions.map((region) => [
    region.type,
    new Date(0, 0, 0, 0, 0, 0, region.start),
    new Date(0, 0, 0, 0, 0, 0, region.end),
  ]);
  return [columns, ...rows];
};

export const getChartHeight = (regions: ReportTypeAPI['regions']) => {
  const uniqueArray = uniqBy(prop('type'), regions);
  const rowHeight = 41;
  return uniqueArray.length * rowHeight + 50;
};
